var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9399CB01-692B-48D5-92CF-2E0A9A34E0D6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login-Page-Form-3",
    transform: "translate(-925.000000, -609.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login",
    transform: "translate(900.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-buttons",
    transform: "translate(0.000000, 448.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-button-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "google",
    transform: "translate(25.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.87566406,13.294875 L4.109875,16.1536719 L1.31093359,16.2128828 C0.474460938,14.6614102 0,12.8863281 0,11 C0,9.17593359 0.443609375,7.45580859 1.2299375,5.94120313 L1.23053906,5.94120313 L3.72238281,6.39804688 L4.81396094,8.8749375 C4.58549609,9.54099609 4.46097266,10.2559961 4.46097266,11 C4.46105859,11.8074687 4.60732422,12.5811211 4.87566406,13.294875 Z",
    id: "Shape",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8078008,8.9450625 C21.9341289,9.61047656 22,10.2976758 22,11 C22,11.7875312 21.9171992,12.5557266 21.7594609,13.2967227 C21.2239844,15.8182578 19.824793,18.0200625 17.8865156,19.5781953 L17.8859141,19.5775937 L14.7473047,19.4174492 L14.3030937,16.6444609 C15.5892344,15.8901875 16.5943594,14.709793 17.1238203,13.2967227 L11.2418281,13.2967227 L11.2418281,8.9450625 L17.2096289,8.9450625 L21.8078008,8.9450625 L21.8078008,8.9450625 Z",
    id: "Shape",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8858711,19.5775938 L17.8864727,19.5781953 C16.0013906,21.0934023 13.6067422,22 11,22 C6.81093359,22 3.16885937,19.6585898 1.31093359,16.2129258 L4.87566406,13.294918 C5.80460547,15.7741289 8.19620313,17.5389844 11,17.5389844 C12.2051445,17.5389844 13.3341914,17.2131953 14.3030078,16.6444609 L17.8858711,19.5775938 Z",
    id: "Shape",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0212656,2.53240625 L14.4577383,5.4498125 C13.4550625,4.82307031 12.2698125,4.46101562 11,4.46101562 C8.13273828,4.46101562 5.69641016,6.30682422 4.81400391,8.8749375 L1.23053906,5.94120312 L1.2299375,5.94120312 C3.06066406,2.41153516 6.74867188,0 11,0 C13.6690039,0 16.1162031,0.950726562 18.0212656,2.53240625 Z",
    id: "Shape",
    fill: "#F14336"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.11a80035.svg";
export { ForwardRef as ReactComponent };